import type { ReactNode } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import clsx from 'clsx';
import styles from './AppTabs.module.scss';

export interface AppTabItem {
  value: string;
  label: string;
  content: ReactNode;
  disabled?: boolean;
}

export interface AppTabsProps {
  tabs: AppTabItem[];
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
}

export function AppTabs({ tabs, defaultValue, value, onValueChange, className }: AppTabsProps) {
  return (
    <Tabs.Root
      className={clsx(styles.root, className)}
      defaultValue={defaultValue ?? tabs[0]?.value}
      value={value}
      onValueChange={onValueChange}
    >
      <Tabs.List className={styles.list}>
        {tabs.map((tab) => (
          <Tabs.Trigger
            key={tab.value}
            value={tab.value}
            disabled={tab.disabled}
            className={styles.trigger}
          >
            {tab.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
      {tabs.map((tab) => (
        <Tabs.Content key={tab.value} value={tab.value} className={styles.content}>
          {tab.content}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
}
